/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import ReservaDeSangueStore from '@/components/SolicitacaoCirurgia/store/ReservaDeSangueStore'
import ConfigSolicitacaoCirurgiaStore from '@/components/Configuracoes/store/ConfigSolicitacaoCirurgiaStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import AgendamentoBackofficeStore from '@/components/AgendamentoBackoffice/Store/AgendamentoBackofficeStore'
import AgendamentoBackofficeAutorizacaoStore from '@/components/AgendamentoBackoffice/Store/AgendamentoBackofficeAutorizacaoStore'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import ContestacaoMedicaStore from '@/components/ContestacaoMedica/Store/ContestacaoMedicaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import ConfirmacaoCirurgicaStore from '@/components/confirmacao-cirurgica/store/confirmacao-cirurgica-store'

import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import ChatStore from '@/components/Chat/Store/ChatStore'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import SnackbarStore from '@/components/Snackbar/Store/SnackbarStore'
import ConfiguracaoNotificacoesStore from '@/components/ConfiguracaoNotificacoes/Store/ConfiguracaoNotificacoesStore'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import AjudaStore from './ajuda/AjudaStore'

import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import GarantiaMinimaStore from '@/components/RemuneracaoMedica/financeiro/Store/GarantiaMinimaStore'
import CalculoTetoStore from '@/components/RemuneracaoMedica/financeiro/Store/CalculoTetoStore'
import RecalcularProcedimentosStore from '@/components/RemuneracaoMedica/financeiro/Store/RecalcularProcedimentosStore'
import FeriadoStore from '@/components/RemuneracaoMedica/financeiro/Store/FeriadoStore'
import TransacaoFinanceiraStore from '@/components/RemuneracaoMedica/financeiro/Store/TransacaoFinanceiraStore'
import CentroDeCustoStore from '@/components/RemuneracaoMedica/financeiro/Store/CentroDeCustoStore'
import OperadoraHospitalStore from '@/components/RemuneracaoMedica/financeiro/Store/OperadoraHospitalStore'
import AgendaGarantiaMinimaStore from '@/components/RemuneracaoMedica/financeiro/Store/AgendaGarantiaMinimaStore'
import CadastroLayoutEmailStore from '@/components/RemuneracaoMedica/financeiro/Store/CadastroLayoutEmailStore'
import BackofficeNavigationStore from '@/components/Backoffice/NavBar/Store/BackofficeNavigationStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import BackofficeSuprimentosStore from '@/components/Backoffice/Store/BackofficeSuprimentosStore'
import BackofficePreAnestesicoStore from '@/components/Backoffice/Store/BackofficePreAnestesicoStore'
import BackofficeMapaCirurgicoStore from '@/components/Backoffice/Store/BackofficeMapaCirurgicoStore'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'
import BackofficeNotificacoesStore from '@/components/Backoffice/Store/BackofficeNotificacoesStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeDataAgendamentoStore from '@/components/Backoffice/Store/BackofficeDataAgendamentoStore'
import BackofficeAgenciaTransfusionalStore from '@/components/Backoffice/Store/BackofficeAgenciaTransfusionalStore'
import BackofficeOrcamentoStore from '@/components/Backoffice/Store/BackofficeOrcamentoStore'
import BackofficeFidelizacaoStore from '@/components/Backoffice/Store/BackofficeFidelizacaoStore'
import BackofficeMapaCirurgicoGradeStore from '@/components/Backoffice/Store/BackofficeMapaCirurgicoGradeStore'
import BackofficeRegulacaoStore from '@/components/Backoffice/Store/BackofficeRegulacaoStore'
import BackofficeTempoCirurgicoPorProcedimentoStore from '@/components/Backoffice/Store/BackofficeTempoCirurgicoPorProcedimentoStore'
import BackofficeProcedimentoHospitalDiaStore from '@/components/Backoffice/Store/BackofficeProcedimentoHospitalDiaStore'
import BackofficeMotivoRecusaOrcamentoStore from '@/components/Backoffice/Store/BackofficeMotivoRecusaOrcamentoStore'
import ConfigUsuarioStore from '@/components/Configuracoes/store/ConfigUsuarioStore'
import ConfigPerfilStore from '@/components/Configuracoes/store/ConfigPerfilStore'
import BackofficeChatStore from '@/views/backoffice-chat/store/backoffice-chat-store'
import FinanceiroBackofficeChatStore from '@/views/financeiro-backoffice-chat/backoffice-chat-store'
import BackofficeModalChatStore from '@/views/backoffice-chat/store/backoffice-modal-chat-store'
import BackofficeFarmaciaStore from '@/components/Backoffice/Store/BackofficeFarmaciaStore'
import ChatAgendamentoStore from '@/components/chat-agendamento/store/chat-agendamento-store'
import ChatAgendamentoPendenciaStore from '@/components/chat-agendamento-pendencia/store/chat-agendamento-pendencia-store'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'
import ConfigIntegracaoOperadoraStore from '@/components/Configuracoes/store/ConfigIntegracaoOperadoraStore'
import ConfigIntegradorFinxStore from '@/components/Configuracoes/store/ConfigIntegradorFinxStore'
import SolicitacaoClinicaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoClinicaStore'
import HomeRemuneracaoStore from '@/components/Home/Store/HomeRemuneracaoStore'
import HomeAgendamentoStore from '@/components/Home/Store/HomeAgendamentoStore'
import HomeAlertasStore from '@/components/Home/Store/HomeAlertasStore'
import HomeNavigationStore from '@/components/Home/Store/HomeNavigationStore'
import HomeTransitoriaStore from '@/components/Home/Store/HomeTransitoriaStore'
import NetPromoterScoreStore from '@/components/NetPromoterScore/Store/NetPromoterScoreStore'
import ChatComentarioStore from '@/components/chat-solicitacao-comentario/store/chat-solicitacao-comentario-store'
import ChatFinanceiroStore from '@/components/financeiro-chat/store/chat-financeiro-store'

import SuporteProcedimentosStore from '@/components/Suporte/Store/SuporteProcedimentosStore'
import SuporteConveniosStore from '@/components/Suporte/Store/SuporteConveniosStore'
import SuporteEquipamentosStore from '@/components/Suporte/Store/SuporteEquipamentosStore'
import SuporteFornecedoresStore from '@/components/Suporte/Store/SuporteFornecedoresStore'
import SuporteCaixasCirurgicasStore from '@/components/Suporte/Store/SuporteCaixasCirurgicasStore'
import SuporteAnestesistasStore from '@/components/Suporte/Store/SuporteAnestesistasStore'
import SuporteHospitaisRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteHospitaisRemuneracaoStore'
import SuporteUsuariosRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteUsuariosRemuneracaoStore'
import SuporteGrupoRepassesRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteGrupoRepassesRemuneracaoStore'
import SuporteHospitaisStore from '@/components/Suporte/Store/SuporteHospitaisStore'
import SuporteHospitalSlaStore from '@/components/Suporte/Store/SuporteHospitalSlaStore'
import SuporteAtualizacaoDePdfStore from '@/components/Suporte/Store/SuporteAtualizacaoDePdfStore'
import SuporteFeedbackStore from '@/components/Suporte/Store/SuporteFeedbackStore'
import SuporteSalasCentrosCirurgicosStore from '@/components/Suporte/Store/SuporteSalasCentrosCirurgicosStore'
import SuporteMotivosCancelamentoStore from '@/components/Suporte/Store/SuporteMotivosCancelamentoStore'
import SuporteMotivoTransferenciaReservaStore from '@/components/Suporte/Store/SuporteMotivoTransferenciaReservaStore'
import SuporteProcedimentosApenasHospitalDiaStore from '@/components/Suporte/Store/SuporteProcedimentosApenasHospitalDiaStore'
import SuportePacientesStore from '@/components/Suporte/Store/SuportePacientesStore'
import SuporteTipoAcomodacaoStore from '@/components/Suporte/Store/SuporteTipoAcomodacaoStore'
import SuportePaisesStore from '@/components/Suporte/Store/SuportePaisesStore'
import SuporteSecretariasStore from '@/components/Suporte/Store/SuporteSecretariasStore'
import SuporteConvitesStore from '@/components/Suporte/Store/SuporteConvitesStore'
import AntecipacaoRecebiveisStore from '@/components/RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import SuporteAlterarSituacaoSolicitacaoStore from '@/components/Suporte/Store/SuporteAlterarSituacaoSolicitacaoStore'
import SuporteSalasRoboticasStore from '@/components/Suporte/Store/SuporteSalasRoboticasStore'

import OperadoraConvenioStore from '@/components/OperadoraConvenio/Store/OperadoraConvenioStore'
import BackofficeSalasEReservasStore from '@/components/Backoffice/Store/BackofficeSalasEReservasStore'
import BackofficeComorbidadesStore from '@/components/Backoffice/Store/BackofficeComorbidadeStore'
import LogoutConfigStore from './LogoutConfigStore'
import RecursosHospitalaresStore from '@/components/RecursosHospitalares/Store/RecursosHospitalaresStore'
import AvaliacaoRiscoApaStore from "@/components/AvaliacaoRiscoApa/Store/AvaliacaoRiscoApaStore";

const modules = {
  SolicitacaoStore,
  FinanceiroBackofficeChatStore,
  SolicitacaoClinicaStore,
  SolicitacaoCirurgiaStore,
  ReservaDeSangueStore,
  ConfigSolicitacaoCirurgiaStore,
  AgendamentoBackofficeStore,
  AgendamentoBackofficeAutorizacaoStore,
  SolicitacaoPendenciaStore,
  RecebimentoStore,
  SolicitacaoComentariosStore,
  ContestacaoMedicaStore,
  SolicitacaoCancelamentoStore,
  ConfirmacaoCirurgicaStore,
  ChatStore,
  HistoricoSolicitacaoStore,
  CadastroMedicoStore,
  SnackbarStore,
  ReservaSalaStore,
  BackofficeContratosStore,
  FinanceiroStore,
  GarantiaMinimaStore,
  CalculoTetoStore,
  RecalcularProcedimentosStore,
  FeriadoStore,
  TransacaoFinanceiraStore,
  CentroDeCustoStore,
  OperadoraHospitalStore,
  AgendaGarantiaMinimaStore,
  CadastroLayoutEmailStore,
  ConfiguracaoNotificacoesStore,
  BackofficeNavigationStore,
  BackofficeAgendamentoStore,
  BackofficeAutorizacaoStore,
  BackofficeSuprimentosStore,
  BackofficePreAnestesicoStore,
  BackofficeCadastroMedicoStore,
  BackofficeMapaCirurgicoStore,
  BackofficeGlobalStore,
  BackofficeNotificacoesStore,
  BackofficeDataAgendamentoStore,
  BackofficeAgenciaTransfusionalStore,
  BackofficeOrcamentoStore,
  BackofficeFidelizacaoStore,
  BackofficeMapaCirurgicoGradeStore,
  BackofficeRegulacaoStore,
  BackofficeTempoCirurgicoPorProcedimentoStore,
  BackofficeProcedimentoHospitalDiaStore,
  BackofficeMotivoRecusaOrcamentoStore,
  BackofficeComorbidadesStore,
  BackofficeChatStore,
  BackofficeModalChatStore,
  BackofficeFarmaciaStore,
  ChatAgendamentoStore,
  ChatAgendamentoPendenciaStore,
  ChatComentarioStore,
  ConfigUsuarioStore,
  ConfigPerfilStore,
  HistoricoSituacaoStore,
  ConfigIntegracaoOperadoraStore,
  ConfigIntegradorFinxStore,
  HomeRemuneracaoStore,
  HomeAgendamentoStore,
  HomeAlertasStore,
  HomeNavigationStore,
  HomeTransitoriaStore,
  NetPromoterScoreStore,
  ChatFinanceiroStore,
  SuporteProcedimentosStore,
  SuporteConveniosStore,
  SuporteEquipamentosStore,
  SuporteFornecedoresStore,
  SuporteCaixasCirurgicasStore,
  SuporteAnestesistasStore,
  SuporteHospitaisRemuneracaoStore,
  SuporteUsuariosRemuneracaoStore,
  SuporteGrupoRepassesRemuneracaoStore,
  SuporteHospitaisStore,
  SuporteHospitalSlaStore,
  SuporteAtualizacaoDePdfStore,
  SuporteFeedbackStore,
  SuporteSalasCentrosCirurgicosStore,
  SuporteMotivosCancelamentoStore,
  SuporteMotivoTransferenciaReservaStore,
  SuporteProcedimentosApenasHospitalDiaStore,
  SuportePacientesStore,
  SuporteTipoAcomodacaoStore,
  SuportePaisesStore,
  SuporteSalasRoboticasStore,
  RegrasDeCalculoStore,
  AntecipacaoRecebiveisStore,
  SuporteAlterarSituacaoSolicitacaoStore,
  OperadoraConvenioStore,
  BackofficeSalasEReservasStore,
  SuporteSecretariasStore,
  AjudaStore,
  SuporteConvitesStore,
  LogoutConfigStore,
  RecursosHospitalaresStore,
  AvaliacaoRiscoApaStore,
}

Vue.use(Vuex)

const store = new Vuex.Store({ modules })

export default store
